import { Star } from "lucide-react";
import { REVIEWS } from "@/config/business";

const Stars = ({ rating, name }) => (
  <div
    className="flex gap-1"
    role="img"
    aria-label={`Rated ${rating} out of 5 stars by ${name}`}
  >
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        className={`h-4 w-4 ${
          i < rating ? "fill-[#C5A059] text-[#C5A059]" : "fill-[#E7E2DA] text-[#E7E2DA]"
        }`}
        aria-hidden="true"
      />
    ))}
  </div>
);

const Reviews = () => (
  <section id="reviews" className="scroll-mt-24 py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#9E7B36]">
          Guest Stories
        </p>
        <h2 className="mt-3 font-serif text-3xl font-medium tracking-tight text-[#1C1917] sm:text-4xl">
          What Our Guests Say
        </h2>
      </div>
      <div data-testid="reviews-list-container" className="mt-12 grid gap-6 md:grid-cols-3">
        {REVIEWS.map((review) => (
          <blockquote
            key={review.name}
            className="flex flex-col rounded-2xl border border-[#E7E2DA] bg-white p-6 shadow-[0_4px_20px_-2px_rgba(44,39,32,0.05)] sm:p-7"
          >
            <Stars rating={review.rating} name={review.name} />
            <p className="mt-4 flex-1 text-sm leading-relaxed text-[#57534E]">
              &ldquo;{review.text}&rdquo;
            </p>
            <footer className="mt-5 border-t border-[#E7E2DA] pt-4">
              <cite className="font-serif text-lg font-medium not-italic text-[#1C1917]">
                {review.name}
              </cite>
            </footer>
          </blockquote>
        ))}
      </div>
    </div>
  </section>
);

export default Reviews;
